import client from 'providers/fetchClient'

export const getOrdersHistory = async ({ id, sortBy, pagination, search, ...filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get('/package-orders', { params })

  return {
    history: data?.data,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const getPackagesBalance = params => client.get('/packages-balance', { params })

export const BuyPackges = order => client.post('/package-orders', order)

export const getOrder = id => client.get(`/package-orders/${id}`)

export const getAvailablePackages = () => client.get('/available-packages')

export const createOrderNoPayment = data => client.post('/package-orders/no-payment', data)
